import { IGetState } from '../../../../../../../../types/types';
import { Dispatch, ThunkAction } from '../../../../../../../../types/actions';
import { root } from '../../../../../../../../store/constants';

export const onClickOutside = (): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        root.App.Helpers.googleDriveOpenDialogue.picker.setVisible(false);
        root.App.Helpers.googleDriveOpenDialogue.onCancel();
    };
    return action;
};
